import {
  ServiceAgreementRole,
  ServiceAgreementsResponse,
} from 'ogp/services/service-agreements.types';

export const useGetCollegialLendingScreenTabs = (
  data: ServiceAgreementsResponse,
  role: ServiceAgreementRole
) => {
  return data.filter((agreement) => agreement.serviceAgreementPartyRole === role);
};
